import React, { useCallback, useEffect, useRef, useState } from 'react';
import Lottie, { AnimationDirection, LottieRefCurrentProps } from 'lottie-react';
import LikeLottie from '../../lottie/LikeLottie.json';

export const LikeButton = ({isFav, onPress} : {isFav: boolean, onPress: (f: boolean) => void}) => {
  const [fav, setFav] = useState(isFav);
  const lottieRef = useRef<LottieRefCurrentProps | null>(null);

  useEffect(() => {
    setFav(isFav)
    if (lottieRef.current && fav!==isFav) {
      lottieRef.current.goToAndStop(isFav ? 30 : 0, true);
    }
  }, [isFav]);

  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.goToAndStop(isFav ? 30 : 0, true);
    }
  }, []);

  const playSegment = (segments: any, direction: AnimationDirection) => {
    lottieRef?.current?.setDirection(direction);
    lottieRef?.current?.playSegments(segments, true);
  };

  const toggleFavorite = useCallback((isFavorite: boolean) => {
    if (!isFavorite) {
      playSegment([0, 30], 1); // лайк
    } else {
      playSegment([30, 0], -1); // анлайк
    }
    setFav(!isFavorite)
    onPress(isFavorite)
  }, []);

  return (
    <div style={{ cursor: 'pointer', width: 24, height: 24 }} onClick={() => toggleFavorite(fav)}>
      <Lottie
        lottieRef={lottieRef}
        animationData={LikeLottie}
        loop={false}
        autoplay={false}
        style={{ marginTop: -7 }}
      />
    </div>
  )
}
